var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"user-rating-link",attrs:{"to":_vm.toRoute}},[_c('span',{staticClass:"user-rating-link-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }